import styled, { css } from 'styled-components';

import type { TBgColor } from '@/components/_promo/templates/BanksBenefitsTemplate/styled';
import { device } from '@/styles/helpers';

interface IScBanksLogosListWrapperProps {
  $bgColor?: TBgColor;
  $useSizesOnMobile?: boolean;
}

export const ScBanksLogosListWrapper = styled.div<IScBanksLogosListWrapperProps>`
  .bank {
    display: flex;
    position: relative;
    justify-content: center;
    background: ${({ theme, $bgColor }) =>
      $bgColor === 'blue' ? theme.darkIndigo : theme.grayDarkColor};
    border-radius: 12px;
    height: 56px;
    width: 100%;
    max-width: 195px;
    align-items: center;
    padding: 0 20px;

    .bank-img {
      object-fit: contain;
      display: block;
    }
  }
  @media (${device.mobile}) {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    background: ${({ theme, $bgColor }) =>
      $bgColor === 'blue' ? theme.darkIndigo : theme.grayDarkColor};
    flex-wrap: wrap;
    margin-top: 16px;
    padding: 16px;
    width: 100%;
    border-radius: 12px;
    height: fit-content;

    .bank {
      background-color: transparent;

      ${({ $useSizesOnMobile }) =>
        !$useSizesOnMobile &&
        css`
          width: 62px;
          height: 20px;

          .bank-img {
            width: 62px;
            height: 20px;
          }
        `}
    }
  }
  @media (${device.mobileXS}) {
    justify-content: center;
  }
`;
